export default __webpack_public_path__ + "static/media/icon-contratos.8dda5d23.svg";